import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

const getSaveModified = (state) => resolveProp('profile.modified', state);

export default createSelector(getSaveModified, (modified) => modified);
